const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

interface BlankPickerProps {
  onPick: (letter: string) => void;
  onCancel: () => void;
}

/** Full-screen overlay with a 26-letter grid (spec 10.3 blank-tile picker). */
export function BlankPicker({ onPick, onCancel }: BlankPickerProps) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Choose a letter for your blank tile"
      className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 p-4"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-sm rounded-xl bg-white p-4 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-center text-lg font-bold">Blank tile</h2>
        <p className="mt-1 text-center text-sm text-stone-500">
          Choose the letter this blank will play as.
        </p>
        <div className="mt-4 grid grid-cols-6 gap-1.5">
          {LETTERS.map((letter) => (
            <button
              key={letter}
              type="button"
              onClick={() => onPick(letter)}
              className="flex h-11 items-center justify-center rounded-md border-b-2 border-tile-edge bg-tile-face text-lg font-bold hover:bg-amber-100"
            >
              {letter}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={onCancel}
          className="mt-4 w-full rounded-md border border-stone-300 px-4 py-2 text-sm font-medium text-stone-600 hover:bg-stone-50"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
